<template>
	<div class="app-container" 
	:lang="$i18n.locale"
	v-loading.fullscreen="uploadloading" :element-loading-text="$t('tipsInfo.uploading')"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="listHeader">
			<i></i><span>{{$t('generalTradeOrder.gtOrderList')}}</span>
		</div>
		<el-form style="margin:10px 0 0 0" :model="queryParams" ref="queryParams" :inline="true"
			label-width="auto">
			<el-form-item label prop="awbNo">
				<el-input v-model.trim="queryParams.awbNo" clearable type="textarea"
					:placeholder="$t('commonInfo.orderNoColumn')" style="width: 200px;"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button icon="el-icon-search" type="primary" @click="handleSearch">
					{{$t('commonInfo.searchBtn')}}</el-button>
				<el-button icon="el-icon-refresh" type="primary" @click="getlist">
					{{$t('commonInfo.refreshBtn')}}</el-button>
				<el-button icon="el-icon-refresh" @click="handleReset">{{$t('commonInfo.dialogBtnReset')}}
				</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="tableData" ref="generalTradeOrderTable" border style="width: 100%;font-size: 16px;"
			v-loading="loading" >
			<el-table-column :label="$t('commonInfo.orderNoColumn')" prop="awbNo" min-width="160"
				align="center"></el-table-column>
			<el-table-column :label="$t('generalTradeOrder.businessType')" align="center" min-width="140" prop="businessType">
			  <template slot-scope="{row}">
			    <span>{{row.businessType}}</span>
			    <div v-if="row.fromCountry && row.fromCountry != ''" class="countryLine">
			      <label>{{returnCountryName(row.fromCountry)}}</label>
			      <i class="el-icon-right"></i>
			      <label>{{returnCountryName(row.destCountry)}}</label>
			    </div>
			  </template>
			</el-table-column>
			<el-table-column :label="$t('generalTradeOrder.containerType')" align="center" min-width="140" prop="containerType">
			  <template slot-scope="{row}">
			    <el-tag v-if="row.containerType === 1" type="primary">{{$t('generalTradeOrder.fullContainerLoad')}}</el-tag>
			    <el-tag v-if="row.containerType === 2" type="primary">{{$t('generalTradeOrder.lessThanContainerLoad')}}</el-tag>
			  </template>
			</el-table-column>
			<el-table-column :label="$t('generalTradeOrder.blNo')" align="center" min-width="150" prop="blNo"/>
			<el-table-column :label="$t('generalTradeOrder.containerNo')" align="center" min-width="130" prop="containerNoList"/>
			<el-table-column :label="$t('generalTradeOrder.containerAmount')" align="center" min-width="160" prop="containerNum"/>
			<el-table-column :label="$t('generalTradeOrder.etd')" align="center" min-width="140" prop="expectArrivePortDate"/>
			<el-table-column :label="$t('commonInfo.statusColumn')" align="center" min-width="140" prop="description">
				<template slot-scope="{ row }">
					<span v-if="$i18n.locale == 'zh'">{{row.description}}</span>
					<span v-else>{{row.enDescription}}</span>
				</template>
			</el-table-column>
			<!-- <el-table-column :label="$t('commonInfo.createTimeColumn')" prop="initTime" align="center" min-width="180">
			</el-table-column> -->
			<el-table-column :label="$t('commonInfo.operationColumn')" class-name="small-padding fixed-width"
				fixed="right" width="120" align="center" style="padding-right:0">
				<template slot-scope="{ row }">
					<el-button type="text" size="small" @click="handleCheckOTrackingInfo(row.awbNo)"
						icon="el-icon-s-promotion">{{$t('commonInfo.actiontrack')}}</el-button>
					<el-dropdown style="margin-left: 10px;" @command="handleCommand">
						<span style="font-size: 12px; color: #409EFF;"
							class="el-dropdown-link">{{$t('commonInfo.moreAction')}}<i
								class="el-icon-arrow-down el-icon--right"></i></span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-if="row.blFileUrl && row.blFileUrl != ''" :command="{'command':'a','row':row}" icon="el-icon-download">
								{{ $t('generalTradeOrder.blFile') }}</el-dropdown-item>
						  <el-dropdown-item v-if="row.packlistFileUrl && row.packlistFileUrl != ''" :command="{'command':'b','row':row}" icon="el-icon-download">
						  	{{ $t('generalTradeOrder.productFile') }}</el-dropdown-item>
							<el-dropdown-item v-if="row.fulfillmentFileUrl && row.fulfillmentFileUrl != ''" :command="{'command':'c','row':row}" icon="el-icon-download">
								{{ $t('generalTradeOrder.customsDeclarationForm') }}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
		</el-table>
		<div class="pageBottom">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryParams.page" :page-sizes="[10, 20, 30, 40]" :page-size="queryParams.limit"
				layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
		</div>
		<!-- 查看轨迹信息 -->
		<CheckTrackingInfo :isShow="checkTrackingPopup" :rowId="rowId"></CheckTrackingInfo>
	</div>
</template>

<script>
	import CheckTrackingInfo from './checkTrackingInfo.vue'
	
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	export default {
		components: {
			CheckTrackingInfo,
		},
		data() {
			return {
				//一般贸易
				uploadloading:false,
				
				queryParams: {
					page: 1,
					limit: 10,
					awbNo:'',
					awbNoList:[],
				},
				tableData: [],
				loading: false,
				total: 0,

				// 查看轨迹信息
				checkTrackingPopup:false,
				rowId:'',
			}
		},
		//方法集合
		methods: {
			// 分页条数
			handleSizeChange(size) {
				this.queryParams.limit = size;
				this.queryParams.page = 1;
				this.getlist();
			},
			// 分页页数
			handleCurrentChange(page) {
				this.queryParams.page = page;
				this.getlist();
			},
			// 搜索空运订单
			handleSearch() {
				if (this.queryParams.awbNo != null && this.queryParams.awbNo != '') {
					this.queryParams.awbNoList = this.strToArr(this.queryParams.awbNo)
				} else {
					this.queryParams.awbNoList = [];
				}
				this.queryParams.page = 1;
				this.getlist();
			},
			// 重置
			handleReset() {
				this.queryParams = {
					page: 1,
					limit: 10,
					awbNo: '',
					awbNoList:[]
				}
				this.getlist();
			},
			// 返回国家信息
			returnCountryName(val){
				let name = '';
				switch(val){
					case '1': name = this.$t('commonInfo.sa'); break;
					case '2': name = this.$t('commonInfo.ae'); break;
					case '3': name = this.$t('commonInfo.cn'); break;
				}
				return name
			},
			// 获取列表
			async getlist() {
				this.loading = true;
				this.tableData = [];
				const res = await this.$http.post("/toborder/generalTrade/order/page", this.queryParams);
			
				if (res.code === 200) {
					let data = res.data.list;
					// 总共有多少条数据，分页
					this.total = res.data.totalCount;
					this.tableData = data;
					this.loading = false;
				} else {
					this.$message.error(res.msg);
					this.loading = false;
				}
			},
			// 列表更多操作
			handleCommand(val) {
				let row = val.row;
				// 判断操作按钮
				switch (val.command) {
					// 下载提单文件
					case 'a':
						this.handleDownloadFile(row.blFileUrl);
						break;
					// 下载清单文件
					case 'b':
						this.handleDownloadFile(row.packlistFileUrl);
						break;
					// 下载报关底单文件
					case 'c':
						this.handleDownloadFile(row.fulfillmentFileUrl);
						break;
				}
			},
			// 下载文件
			handleDownloadFile(url){
				window.open(url);
			},
			// 查看轨迹信息
			handleCheckOTrackingInfo(id){
				this.checkTrackingPopup = true;
				this.rowId = id;
			},
			
		},
		created() {
			this.getlist();
		},
	}
</script>

<style scoped>
	.listHeader {
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-size: 22px;
	}
	
	.listHeader i {
		width: 4px;
		height: 40px;
		display: inline-block;
		background-color: #0077AA;
		float: left;
		margin: 5px 10px;
	}
	
	.listHeader span {
		display: inline-block;
		float: left;
	}
	
	.app-container {
		padding: 10px;
	}
	.countryLine {
	  margin-top: 5px;
	}
	.countryLine i{
	  margin: 0 5px;
	}
	.countryLine label:nth-child(1){
	  color: #1890ff;
	}
	.countryLine label:nth-child(3){
	  color: #11d85a;
	}
</style>
<style scoped lang="scss">
	// 阿拉伯语
	[lang="ar"] {
		.listHeader{
			i{
				float: right;
			}
			span{
				float: right;
			}
		}
		
		.el-form-item__content{
			.el-button--primary{
				margin-left: 10px;
			}
		}
		// 表格
		::v-deep .el-table__fixed-right{
			left: 0;
			right: auto;
			.el-table__fixed-body-wrapper{
				left: 0;
				right: auto;
			}
		}
		::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper{
			left: 0;
			right: auto;
		}
		::v-deep .fixed-width .el-button{
			margin: 0 5px 0 0 !important;
			i{
				margin-left: 5px;
			}
		}
		::v-deep .el-dropdown{
			margin: 0 5px 0 0 !important;
			.batchInfoItem{
				width: 20px;
				height: 20px;
				left: -15px;
				right: auto;
				top:-5px;
			}
			span{
				margin-left: -5px;
				float: right;
			}
			i{
				float: right;
				margin: 6px 0 0 5px;
			}
		}
		::v-deep .is-dot {
			left: -2px;
			right: auto;
			top: 6px;
		}
		::v-deep .el-dialog__headerbtn{
			right: auto;
			left: 20px;
		}
		::v-deep .el-select .el-tag{
			margin: 0 5px;
		}
		::v-deep .el-select .el-tag__close.el-icon-close{
			right: 5px;
		}
	}
</style>